import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect, useContext } from 'react';
import dayjs from "../dayjs-config";
import LocalizationContext from "../LocalizationProvider/LocalizationContext";

var useLocale = function useLocale() {
  var _useContext = useContext(LocalizationContext),
      language = _useContext.language;

  var _useState = useState(language),
      _useState2 = _slicedToArray(_useState, 2),
      locale = _useState2[0],
      setLocale = _useState2[1];

  useEffect(function () {
    var updateDayjsLocale = function updateDayjsLocale() {
      dayjs.locale(locale);
    };

    updateDayjsLocale();
  }, [locale]);

  var changeLocale = function changeLocale(newLocale) {
    setLocale(newLocale);
  };

  return {
    locale: dayjs.locale(),
    changeLocale: changeLocale
  };
};

export default useLocale;